import React, { useState, useEffect ,useRef } from 'react';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import Swal from 'sweetalert2';
import { Container, Button, Paper, Table, TableHead, TableBody, TableRow,FormControlLabel , TableCell, Checkbox ,TableContainer,TextField,Stack,Grid  } from '@mui/material';
import { BASE_URL } from "../../App";
import CustomTextField from "../Reusable/Numerictext";
import { SelectSearch } from '../Reusable/SelectBox';
import { Row, Col, Card } from 'antd';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';
import { UploadOutlined } from '@ant-design/icons';
import { Button as Btn,  Upload, message } from 'antd';
import Crilogo from '../image/cri_logo.jpg';
import {Backdrop, CircularProgress, } from '@mui/material';

const DeliveryChallan = () => {
    const [serviceClaims, setServiceClaims] = useState([]);
    const [open1, setOpen1] = React.useState(false);
    // const [status, setstatus] = useState([]);
    
   
    const [callheader, setcallheader] = useState([]);
    const [dealerdesc, setdealerdesc] = useState([]);
    const [itemdesc, setitemdes] = useState([]);

    
   
   
    const [selectedRowData, setSelectedRowData] = useState(null);
	
    const [serialNoImage, setSerialNoImage] = useState([]);
    const [openCard, setOpenCard] = useState(false);
    const [showTable, setShowTable] = useState(true);
    const [header, setHeader] = useState([]);
    const [callHeader, setCallHeader] = useState([]);
    const [dealerDesc, setDealerDesc] = useState([]);
    const [itemDesc, setItemDesc] = useState([]);
    const [loading, setloading] = React.useState(false);
    const [confirmClicked, setConfirmClicked] = useState(false);
  const [balanceNotCorrectClicked, setBalanceNotCorrectClicked] = useState(false);
  const [pending, setPending] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [remarks, setRemarks] = useState('');
const [authorizer, setAuthorizer] = useState('');
const [designation, setDesignation] = useState('');
const [cbalance, setcbalance] = useState('');
const [docFile, setDocFile] = useState(null); 
const [MessageState, setMessageState] = useState(''); 
const [shouldRenderCard, setShouldRenderCard] = useState(false);
    const login_id = localStorage.getItem("LOGIN_ID");
    const [firstRowData, setFirstRowData] = useState(null);
    const [printdata, setprintdata] = useState('');
    const [balanceAsOnDate, setBalanceAsOnDate] = useState();
    const [refno, setrefno] = useState();
    const [month, setMonth] = useState(null);
    const [financialYear, setFinancialYear] = useState(null);
    const [todayDate, setTodayDate] =useState(null);
    const [Partycode, setPartycode] = useState(null);
    const [PartyName, setPartyName] = useState(null);
    const [Address, setAddress] = useState(null);
    const [City, setCity] = useState(null);
    const [PinCode, setPinCode] = useState(null);
    const [PhoneNumber, setPhoneNumber] =useState(null);
    const [BalanceNature, setBalanceNature] = useState(null);
    const [CurrentBalance, setCurrentBalance] = useState(null);
    const [date1, setdate1] = useState(null);
    const [CurrentBalance1, setCurrentBalance1] = useState(null);
    const [Text, setText] = useState(null);
    const [BalanceinText, setBalanceinTextText] = useState(null);
    const [CustomerAmount, setCustomerAmount] = useState(null);
    const [AuthorizerName, setAuthorizerName] = useState(null);
    const [Auth_Design, setAuth_Design] = useState(null);
    const [ConfirmedDate, setConfirmedDate] = useState(null);
    const [Msg, setMsg] = useState(null);
    const [StatusCF, setStatusCF] = useState(null);
    const [Print, setPrint] = useState(false);
    //const [printDisabled, setPrintDisabled] = useState(false);
    const hiddenFileInputRef = useRef(null);
    
    const handleRemarksChange = (event) => {
      setRemarks(event.target.value);
  };
  
  const handleAuthorizerChange = (event) => {
    const value = event.target.value;
    
    const newValue = value.replace(/[^A-Za-z\s]/g, '');
    setAuthorizer(newValue);
   // setAuthorizer(event.target.value);
  };
  
  const handleDesignationChange = (event) => {
    const value = event.target.value;
    // Regex to allow only alphabetic characters and spaces
    const newValue = value.replace(/[^A-Za-z\s]/g, '');
    setDesignation(newValue);
    // setDesignation(event.target.value);
  }; 
  const formatToINR = (value) => {
    const number = Number(value.replace(/,/g, '')); // Remove commas if present
    return number.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }).replace('₹', ''); // Remove ₹ symbol for custom styling
  };
  
  const handlecbalance = (event) => {
    //setcbalance(event.target.value.replace(/[^0-9]/g, ''));  
    setcbalance(event.target.value);
  };
  const severity = MessageState?.includes('Balance not Accepted') ? 'error' : 'info';

  
  const handleFileUploadChange = (file) => {
      setDocFile(file);
  };
  const resetFields = () => {
    // Reset all state variables to their initial values
   // setprintdata('');
    setBalanceAsOnDate('');
    setMonth('');
    setFinancialYear('');
    setrefno('');
    setTodayDate('');
    setPartycode('');
    setPartyName('');
    setAddress('');
    setCity('');
    setPinCode('');
    setPhoneNumber('');
    setBalanceNature('');
    setCurrentBalance('');
    setdate1('');
    setCurrentBalance1('');
    setText('');
    setBalanceinTextText('');
    setCustomerAmount('');
    setAuthorizerName('');
    setAuth_Design('');
    setConfirmedDate('');
    setMsg('');
    
};
  const fetchData = async () => {
    
    try {
      //alert('1');
      setloading(true);
        const response = await axios.post(BASE_URL + '/getbalanceconfirmationdetails', { login_id: login_id });
        if (response.status === 200) {
          setloading(false);
            if (response.data.balanceconfirmation.length > 0 && response.data.balanceconfirmation[0].status === "N") {
                // Call another API here
                const anotherResponse = await axios.post(BASE_URL + '/balanceconfirmationupdatestatus', { login_id: login_id });
                console.log('Second API response:', anotherResponse.data);
                setloading(false);
                // Recall fetchData to update data after second API call
                fetchData();
            }

            if (response.data.balanceconfirmation.length > 0) {
             
              setloading(false);
                const firstRow = response.data.balanceconfirmation[0];
                setFirstRowData(firstRow);
                setcbalance(firstRow.CurrentBalance);
                setServiceClaims(response.data.balanceconfirmation);
                setConfirmClicked(false);
                setPending(false);
                setBalanceNotCorrectClicked(false);
                setMessageState(null);

                if (firstRow.status === 'V') {
                    setShouldRenderCard(true);
                    
                } else if (firstRow.status === 'C') {
                    setShouldRenderCard(false);
                    setMessageState("Balance Confirmed");
                    // Set other state or perform actions as needed
                } else if (firstRow.status === 'F') {
                    setShouldRenderCard(false);
                    setMessageState("Balance not Accepted");
                    // Set other state or perform actions as needed
                } else {
                 
                  setloading(false);
                }
            }
        } else {
       
          setloading(false);
            Swal.fire({
                icon: "warning",
                text: 'Unexpected response status. Please try again.'
            });
        }
    } catch (error) {
      setloading(false);
        if (error.response) {
            Swal.fire({
                icon: "warning",
                text: `Error: ${error.response.data.message}`
            });
        } else if (error.request) {
            console.error('No response received');
        } else {
            console.error('Error setting up the request:', error.message);
        }
    }
};


// useEffect to fetch initial data
useEffect(() => {
    fetchData();
   // handleprint();
}, [login_id]); // Dependency array ensures useEffect runs when login_id changes


const handleSubmit = async () => {
    try {
      
      console.log('status',selectedStatus);
      console.log('docFile',serialNoImage[0]);
      console.log('remarks',remarks);
      console.log('authorizer',authorizer);
      console.log('designation',designation);
       if (selectedStatus === 'C' || selectedStatus === 'F') {
        // if ( selectedStatus === 'F') {
       
        if ( !remarks  || !authorizer || !designation) {
           
            Swal.fire({
                icon: 'info',
                text: 'Please fill Mandatory Fields.'
            });
            return; 
        }
      }
      if ( selectedStatus === 'F') {
        
       const numericBalance = Number(cbalance);

if (isNaN(numericBalance) || numericBalance === 0) {
    Swal.fire({
        icon: 'info',
        text: 'Customer Balance should be a valid'
    });
    return;
}

      
        if (!serialNoImage[0]) {
           
            Swal.fire({
                icon: 'info',
                text: 'Please Upload Required File!'
            });
            return; 
        }
      }
        const formData = new FormData();
        formData.append('login_id', login_id);
        formData.append('status', selectedStatus);
        formData.append('doc', serialNoImage[0]);
        formData.append('filename', docFile ? docFile.name : '');
        formData.append('remarks', remarks);
        formData.append('customeramount', cbalance);
        formData.append('authorizer', authorizer);
        formData.append('designation', designation);
        formData.append('refno', firstRowData.RefNo);
       
        setloading(true);
        const response = await axios.post(BASE_URL + '/updatebalanceconfirmation', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
          setloading(false);
            // Handle success
            Swal.fire({
              icon: 'success',
              text: 'Status updated successfully!'
          });
            // Optionally, refetch data after successful update
            fetchData();
            fetchDataAndProcess();

            
        } else {
          setloading(false);
            Swal.fire({
                icon: "info",
                text: 'Failed to update Balance Confirmation Status. Please try again later.'
            });
        }
    } catch (error) {
      setloading(false);
        console.error('Error updating status:', error);
        Swal.fire({
            icon: "info",
            text: 'Failed to update Balance Confirmation Status. Please try again later.'
        });
    }
};
const formatDatee = (dateString) => {
  try {
    const ddt1 = dateString.replace(/-/g, '/').split('/');
    return `${ddt1[1]}/${ddt1[0]}/${ddt1[2].substring(0, 4)}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};
const getFormattedDate = () => {
  const dateObj = new Date();
  const day = String(dateObj.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Get month (zero-based index, so add 1) and pad
  const year = dateObj.getFullYear(); // Get full year

  return `${day}/${month}/${year}`; // Format: dd-mm-yyyy
};
//31/02/2024
const convertDateFormat = (inputDate) => {
  // Parse input date string into Date object
  const parsedDate = new Date(inputDate);

  // Check if parsedDate is valid
  if (isNaN(parsedDate)) {
    return 'Invalid Date';
  }

  // Format the date into dd/mm/yyyy format
  const day = parsedDate.getDate();
  const month = parsedDate.getMonth() + 1; // Month is zero-indexed
  const year = parsedDate.getFullYear();

  // Create formatted date string
  const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;

  return formattedDate;
};

const numberToWordsIN = (num) => {
  const units = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const numToWords = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else {
      const ten = Math.floor(num / 10);
      const unit = num % 10;
      return `${tens[ten]} ${units[unit]}`.trim();
    }
  };

  const inWords = (num) => {
    if (num === 0) return 'Zero';
    if (num < 100) return numToWords(num);
    if (num < 1000) {
      const hundred = Math.floor(num / 100);
      const remainder = num % 100;
      return `${units[hundred]} Hundred ${numToWords(remainder)}`.trim();
    }
    if (num < 100000) {
      const thousand = Math.floor(num / 1000);
      const remainder = num % 1000;
      return `${inWords(thousand)} Thousand ${inWords(remainder)}`.trim();
    }
    if (num < 10000000) {
      const lakh = Math.floor(num / 100000);
      const remainder = num % 100000;
      return `${inWords(lakh)} Lakh ${inWords(remainder)}`.trim();
    }
    return 'Number too large to convert';
  };

  const formattedNumber = parseFloat(num).toFixed(2); // Ensure two decimal places
  const [rupees, paise] = formattedNumber.split('.'); // Split rupees and paise parts

  const rupeesInWords = inWords(parseInt(rupees, 10));
  const paiseInWords = numToWords(parseInt(paise || '0', 10));

  return `(Rupees ${rupeesInWords} and ${paiseInWords} paise only)`;
};
const fetchDataAndProcess = async () => {
  resetFields();
  try {
      const response = await axios.post(BASE_URL + '/printbalanceconfirmation', {
          login_id: data2, // Replace with your login ID or retrieve from state
      });

      if (response.data && response.data.printbalanceconfirmation && response.data.printbalanceconfirmation.length > 0) {
          const data = response.data.printbalanceconfirmation[0];

          // Process data and set state
          setBalanceAsOnDate(formatDate(data.BalanceAsOnDate));
          setPrint(true);
          //setPrintDisabled(true);
          const ddt1 = data.BalanceAsOnDate.split('-');
          const mon = parseInt(ddt1[1], 10);
          const formattedMonth = mon < 10 ? `0${mon}` : `${mon}`;
          if (formattedMonth === "03") {

          setMonth(12);
          }else{
            setMonth(formattedMonth);
          }

          

          const fy = ddt1[0].substring(2, 4);
          let finyr = parseInt(fy, 10);
          let finyr1 = finyr;
          if (mon <= 3) {
              finyr = finyr - 1;
              setFinancialYear(`${finyr}${finyr1}`);
          } else {
              finyr1 = finyr1 + 1;
              setFinancialYear(`${finyr}${finyr1}`);
          }

          if (data.currentBalanceNature === 'C') {
              setBalanceNature('Credit balance');
          } else {
              setBalanceNature('Debit balance');
          }

          setrefno(data.RefNo);
          setTodayDate(getFormattedDate());
          setPartycode(data.PartyCode);
          setPartyName(data.PartyName);
          setAddress(data.Address);
          setCity(data.City);
          setPinCode(data.PinCode);
          setPhoneNumber(data.PhoneNumber);

          const formattedBalanceText = `in your account of INR ${data.CurrentBalance}/-`;
          setCurrentBalance(formattedBalanceText);

          const date11 = convertDateFormat(data.BalanceAsOnDate);
          setdate1(date11);

          const formattedBalanceText1 = `as on  ${date11}`;
          setCurrentBalance1(formattedBalanceText1);

          setText('Note: This letter of confirmation is automatically generated by Computer and hence no signature is required.');

          const balanceintext = numberToWordsIN(data.CurrentBalance);
          setBalanceinTextText(balanceintext);

          setCustomerAmount(data.CustomerAmount);
          setAuthorizerName(data.AuthorizerName);
          setAuth_Design(data.Auth_Design);
          const cnfdate = convertDateFormat(data.ConfirmedDate);
          setConfirmedDate(cnfdate);
          setStatusCF(data.status);

          if (data.status === 'C') {
              setMsg('Note: The balance is correct. This letter of confirmation is automatically generated by Computer and hence no signature is required.');
          } else if (data.status === 'F') {
              setMsg('Note: The balance is Incorrect. This letter of confirmation is automatically generated by Computer and hence no signature is required.');
          }

          console.log('State variables after processing:', {
              month,
              financialYear,
              refno,
              todayDate,
              Partycode,
              PartyName,
              Address,
              City,
              PinCode,
              PhoneNumber,
              BalanceNature,
              CurrentBalance: formattedBalanceText,
              date1,
              CurrentBalance1: formattedBalanceText1,
              Text,
              BalanceinText: balanceintext,
              CustomerAmount,
              AuthorizerName,
              Auth_Design,
              ConfirmedDate: cnfdate,
              Msg,
              StatusCF: data.status,
          });

          
      } else {
          console.error('Unexpected status code or no data found');
          setPrint(false);
         // setPrintDisabled(false);
          // Handle error or unexpected response
      }
  } catch (error) {
      console.error('Error making API call:', error);
      setPrint(false);
      //setPrintDisabled(false);
      // Handle API call error
  }
};
const handleprint = () => {
  //resetFields(); // Assuming this function resets all state fields
  //alert('1');
 

  fetchDataAndProcess();
  if (Print) {
    openPrintWindow();
    setPrint(false); // Reset state if needed
  }
  else{
    Swal.fire({
      icon: "info",
      text: 'No Records Found'
  });
  }

 
};

// useEffect hook to fetch data on component mount
useEffect(() => {
  fetchDataAndProcess();
}, []);
const data2=login_id;

const openPrintWindow = () => {
  const img = `<img src="${Crilogo}" alt="CRILogo" />`;

  const printWindow = window.open('', '_blank');
 // const printWindow = window.open('');

  
  if (printWindow) {
   // alert(5);
    //if (printWindow) {
    // printWindow.onload = function() {
     //  alert(6);
           printWindow.document.write(`<!DOCTYPE html>
   <html lang="en">
   <head>
       <meta charset="UTF-8">
       <meta name="viewport" content="width=device-width, initial-scale=1.0">
       <title>BALANCE CONFIRMATION LETTER</title>
       <link href="../css/bootstrap.min.css" rel="stylesheet" type="text/css" />
   
      
   
       
      <style >
           
       </style>
   
     </style>
   </head>
   <body style="text-align :justify;font-size: 10px; ">
   
       <div>
           <div id="Print" style="width: 100%; font-size: 15px;" align="center">
                   <table >
                       <tr>
                           <td style="width:20%;">
                               &nbsp;</td>
                           <td style="width:60%;font-size: 14px;
                       font-weight: bold; font-family:'Times New Roman';" align ="center">
                 <strong style="font-family: 'Times New Roman'; font-size: 20px;">C.R.I. PUMPS PRIVATE LIMITED</strong>
   
                               <br />
                                <strong>CORPORATE OFFICE</strong>
                               <br />
                      <strong>7/46-1,KEERNATHAM ROAD, SARAVANAMPATTY,</strong> 
                               <br />
                   <strong>COIMBATORE-641035, TAMILNADU, INDIA</strong>  
                                <br />
                  <strong> GSTIN:33AAACC9497N1Z1</strong>  
                           </td>
                           <td style="width:25%;"><div align="center" >
                             
                            <img id="companyLogo" src="https://res.9appsinstall.com/group3/M00/21/7B/4ZMEAFuYJwuAcbJiAAA3oPsalU4404.png?x-oss-process=style/mq200" alt="logo" style="height: 70%; width: 70%;" /></div></td>
                  
                           </div></td>
                       </tr>
                   </table>
                  
                   <div>
                   </div>
                          
              
           <br /> 
           <br />
            <table style="width:100%"><tr><td style="width:50%"><div align="left" style="font-size :14px">   
           Ref.No:BC/
             
                      ${month}  
             /
             
               ${financialYear}
                  /
                           ${refno}
                <br />
            Date:
                   ${todayDate}
              <br />   
                    <br />        
               To:
                <br />Code:
               ${Partycode}
               <br />
              ${PartyName}
               <br />
              ${Address}
               <br />
               ${City}
               <br />
               Pin:
              ${PinCode}
              
             
               <br />
               </div> </td><td style="width:50%;"><div align="right" >
                    </div></td></tr></table>
                
                               <br />
                    
               <div align="left">
               <strong>Dear Sir/Madam,</strong>
              </div> 
      
                <strong><u>Sub: Balance Confirmation As On
                   ${date1}</u></strong>   
                   <br />
               <br />
               
                <div align="left" style ="text-align :justify">
                   With reference to the above subject, our books of accounts shows the
   
                   ${BalanceNature}
           ${CurrentBalance}
                   
                  
                 ${BalanceinText}
                   ${CurrentBalance1}
   
               </div>
               <br />
                <div align="left" style ="text-align :justify">
             If the amount shown is in agreement with your books, kindly strike-out the paragraph marked (B) below. If the amount shown 
   is not in agreement with your books, kindly furnish the details in the paragraph marked (B) below and strike-out paragraph 
   (A). In either case, kindly sign at the place provided below mentioning your name and designation and reply to this e-mail 
   acc.coordinator@cripumps.com.
               <br />
                    <br />
               If we do not receive your confirmation within 15 days, we would treat the above balance is correct.
              <br />
               Your prompt response with this request will be appreciated.
               <br />
                    <br />
                  Yours Sincerely
               <br />
               For C.R.I. PUMPS PRIVATE LIMITED 
               <br />
                    <br />
                      ${Text}
                    </div> 
              
                   <br /> 
           <br />
            <strong><u>Balance Confirmation</u></strong>  
                   <br />
           <br />
            
       ${StatusCF === 'C' ? `
           <div id="divcorr" align="left">
               <strong>A</strong> : We confirm that the above stated amount is correct ${CurrentBalance1}
           </div>
       ` : ''}
       
       ${StatusCF === 'F' ? `
           <div id="divincorr" align="left">
               <strong>B</strong>: We state that the above stated amount is not correct as per our records.
               According to our records, Balance as per our book ${CurrentBalance1} was INR ${CustomerAmount} attached along with ledger statement.
           </div>
       ` : ''}
   
   
                   <br />
           <br />
                
                           <div align="left" >
             <strong>Yours faithfully,</strong>  
               <br />
         <br />
               <div  >
             Name of the authorised official:&nbsp;${AuthorizerName} 
               </div>
                             
                               <div  >
             Signature of the authorised official:&nbsp;&nbsp;
               
   
               </div>
                              <div  >
              Designation:&nbsp;${Auth_Design}
               </div>
                             <div  >
              Date:&nbsp;${ConfirmedDate}
               </div>
               </div>
         <br /> 
         <br /> 
               <div align="left" style ="text-align :justify">
              <strong> ${Msg}</strong>
                   
           </div>
                 
                   
                   
           </div>
           <div id="divprint" runat="server" visible="false">
            
           </div>
           <br/>
           <br/>
           <br/>
            <center><p class="copyright">
               &copy; C.R.I. PUMPS PRIVATE LIMITED. All rights reserved.
           </p></center>
          
       </div>
   
     
   
      
   </body>
   </html>`);
        printWindow.document.close();
   let img = printWindow.document.getElementById('companyLogo'); // Adjust selector if necessary
   img.onload = function() {
       // Print and close the print window
      //  setTimeout(() => {
      //   printWindow.print();
      //   printWindow.close();
      // }, 5000); 
   };
   
         //  Close the print window after printing
        //  printWindow.document.close();
        // printWindow.print();
        //   printWindow.close();
  } else {
      console.error('Failed to open print window');
  }
};
const clearFields = () => {
  // Reset or clear the form fields as needed
  // Example:
  //setLoginId('');
  setSelectedStatus('');
  setSerialNoImage([]);
  setDocFile(null);
  setRemarks('');
  setcbalance('');
  setAuthorizer('');
  setDesignation('');
  // Add more fields if needed
}; 


    const handleCheckboxChange = (event) => {
      const { name, checked } = event.target;
  
      switch (name) {
        case 'confirm':
          setConfirmClicked(checked);
          if (checked) {
            setSelectedStatus('C');
            setBalanceNotCorrectClicked(false);
            setPending(false);
            focusFileInput();
          }
          break;
        case 'balanceNotCorrect':
          setBalanceNotCorrectClicked(checked);
          if (checked) {
            setSelectedStatus('F');
            setConfirmClicked(false);
            setPending(false);
            focusFileInput();
            setcbalance(0);
          }
          break;
        case 'pending':
          setPending(checked);
          if (checked) {
            setSelectedStatus('V');
            setConfirmClicked(false);
            setBalanceNotCorrectClicked(false);
          }
          break;
        default:
          break;
      }
    };
    const focusFileInput = () => {
      if (hiddenFileInputRef.current) {
        hiddenFileInputRef.current.click();
      }
    };
    const handleConfirm = () => {
        setSelectedStatus('C');
        setConfirmClicked(true);
        setBalanceNotCorrectClicked(false);
        setPending(false);
      };
    
      const handleBalanceNotCorrect = () => {
        setSelectedStatus('F');
        setBalanceNotCorrectClicked(true);
        setConfirmClicked(false);
        setPending(false);
      };
      const handlepending = () => {
        setSelectedStatus('V');
        setPending(true);
        setBalanceNotCorrectClicked(false);
        setConfirmClicked(false);
      };
    

    

    const options = [
    
    { label: 'Closed', value: 'closed' },
  
];
const [selectedDate, setSelectedDate] = useState(null);

const handleDateChange = (date) => {
    setSelectedDate(date);
};
const acceptedFileTypes = ['application/pdf'];
const createInvoiceImageProps = (image, setImage) => ({
  accept: '.pdf',
  onRemove: (file) => {
    const newFileList = image.filter(item => item.uid !== file.uid);
    setImage(newFileList);
  },
  beforeUpload: (file) => {
    const isAcceptedFileType = acceptedFileTypes.includes(file.type);
    if (!isAcceptedFileType) {
      message.error('You can only upload PDF files!');
      return false;
    }
    setImage([file]);
    return false; 
  },
  fileList: image,
});
const formatDate = (dateString) => {
  // Ensure dateString is in 'YYYY-MM-DD' format
  const dateParts = dateString.split('-');
  const year = dateParts[0];
  const month = parseInt(dateParts[1], 10); // Parse month as integer
  const day = parseInt(dateParts[2], 10);   // Parse day as integer

  // Define month names in abbreviated form
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Format the date in "dd-MMM-yyyy" format
  return `${day}-${months[month - 1]}-${year}`;
};

// doc,filename,partycode,refno,status,authorizername,designation,customeramount

    return (
        <Container>
            <br />
            {showTable && ( 
                <div>
            <center><h3 style={{ padding: '5px', background: '#e3fafe', color: 'black' }} >Balance Confirmation Letter</h3></center>
            <hr />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                             <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Ref.No </TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Party Code</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Party Name</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Current Balance Date</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>CRI Balance</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Balance Nature</TableCell>
                            <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black' }}>Customer Balance</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
    {serviceClaims && serviceClaims.map((row, index) => (
        <TableRow key={index}>
          
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.RefNo}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.PartyCode}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.PartyName}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{formatDate(row.BalanceAsOnDate)}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{formatToINR(row.CurrentBalance)}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}>{row.BalanceNature}</TableCell>
            <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', }}><TextField
                    value={cbalance}
                    
                    onChange={handlecbalance}
type="text"
                    InputProps={{
                      readOnly: !balanceNotCorrectClicked,
                      inputMode: 'text'  
                  }}
                    fullWidth
                    autoFocus 
                /></TableCell>
           
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
            
)}
<br/>

{MessageState && (
          <Alert severity={severity} >
           <b> {MessageState}</b>
          </Alert>
        )}

<br/>




{shouldRenderCard && (
        <Paper className="shadow bg-white rounded">
  <Stack direction="row" spacing={2} alignItems="center">
    {!balanceNotCorrectClicked && !pending && (
      <FormControlLabel
        control={
          <Checkbox
            checked={confirmClicked}
            onChange={handleCheckboxChange}
            name="confirm"
          />
        }
        label="We Confirm The Balance Is Correct"
      />
    )}

    {!confirmClicked && !pending && (
      <FormControlLabel
        control={
          <Checkbox
            checked={balanceNotCorrectClicked}
            onChange={handleCheckboxChange}
            name="balanceNotCorrect"
          />
        }
        label="Balance Is Not Correct"
      />
    )}

    {!confirmClicked && !balanceNotCorrectClicked && (
      <FormControlLabel
        control={
          <Checkbox
            checked={pending}
            onChange={handleCheckboxChange}
            name="pending"
          />
        }
        label="Keep Pending"
      />
    )}
  </Stack>
</Paper>

      )}



      <br/>
      {confirmClicked || balanceNotCorrectClicked ? (
// {balanceNotCorrectClicked ? (
  
  <Card className="shadow bg-white rounded">
    <Stack direction="row" spacing={2}>
      {balanceNotCorrectClicked && (
          <Upload   {...createInvoiceImageProps(serialNoImage, setSerialNoImage)} maxCount={1}>
          <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Account Statements *</Btn>
        </Upload>
      )}
  
<TextField
required
    id="txtRemarks"
    label="Remarks"
    variant="outlined"
    size="small"
    type="text"
    fullWidth
    style={{ flex: 1 }}
    value={remarks}
    onChange={handleRemarksChange}
    inputProps={{ maxLength: 50 }}
/>
<TextField

    required
    id="txtauthorisername"
    label="Name Of The Authorizer"
    variant="outlined"
    size="small"
    type="text"
    fullWidth
    style={{ flex: 1 }}
    value={authorizer}
    onChange={handleAuthorizerChange}
    inputProps={{ maxLength: 50 }}
    
/>
<TextField
required
    id="txtdesign"
    label="Designation"
    variant="outlined"
    size="small"
    type="text"
    fullWidth
    style={{ flex: 1 }}
    value={designation}
    onChange={handleDesignationChange}
    inputProps={{ maxLength: 50 }}
    
/>
    </Stack>
  </Card>
) : null}

<br/>
<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
        <Card className="shadow bg-white rounded">
        <Stack spacing={2} direction="row" >
        {confirmClicked || balanceNotCorrectClicked||pending ? (
        <Button 
  variant="contained" 
  style={{ width: '500px'}}
  onClick={handleSubmit}
   // Disable button if neither option is selected
>
  Submit
</Button>
) : null}

{serviceClaims.length > 0 && (serviceClaims[0].status === 'C' || serviceClaims[0].status === 'F') && (
  <Button
    variant="contained"
    style={{ backgroundColor: '#4caf50', color: '#ffffff', width: '500px'}}
    onClick={handleprint}
   // disabled={printDisabled}
  >
    Print
  </Button>

)}


    </Stack>
    </Card>
     
    
           


        </Container>
    );
};

export default DeliveryChallan;
